export const getPreOptionLinkId = (value) => {
  if (value == null) return null;
  return typeof value === "object" ? value.id : value;
};

export const isPartialTerminationPair = (object) => {
  if (!object) return false;
  if (object.terminationPreOption) return true;
  return object.derivative_action === "create" && getPreOptionLinkId(object.linked_pre_option) != null;
};

export const attachTerminationToPrimary = (group) => {
  if (!group?.primary) return group?.primary;
  if (!group.termination) return group.primary;
  return {
    ...group.primary,
    terminationPreOption: group.termination,
    linked_pre_option: group.primary.linked_pre_option || group.termination.id,
  };
};

export const groupPartialTerminationPreOptions = (preOptions = []) => {
  const items = Array.isArray(preOptions) ? preOptions : [];
  const byId = new Map(items.map((item) => [item.id, item]));
  const used = new Set();
  const groups = [];

  items.forEach((item) => {
    if (used.has(item.id) || item.derivative_action !== "create") return;

    const linkedId = getPreOptionLinkId(item.linked_pre_option);
    let termination = linkedId != null ? byId.get(linkedId) : null;
    if (!termination && item.old_reference_code) {
      termination = items.find(
        (other) =>
          other.derivative_action === "partial_terminate" &&
          other.reference_code === item.old_reference_code
      );
    }

    if (termination && termination.derivative_action === "partial_terminate") {
      used.add(item.id);
      used.add(termination.id);
      groups.push({
        key: `pair-${termination.id}-${item.id}`,
        primary: item,
        termination,
        isPartialPair: true,
      });
    }
  });

  items.forEach((item) => {
    if (used.has(item.id)) return;
    groups.push({
      key: `single-${item.id}`,
      primary: item,
      termination: null,
      isPartialPair: false,
    });
  });

  return groups;
};
